import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Box, Typography, Button, Grid, TextareaAutosize, Snackbar, Alert } from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import axios from 'axios'
import fileDownload from 'js-file-download'
import ItemsList from '../orders/ItemsList'
import legolasApi from '../../api/legolas'


function ShipmentDetails() {
  const navigate = useNavigate();
  const order = useParams();
  const [orderData, setOrderData] = React.useState(null)
  const [openAlert, setOpenAlert] = React.useState(false)
  const [alertText, setAlertText] = React.useState('')

  React.useEffect(() => {
    axios.get(`${legolasApi.url}/orders/${order.id}`).then((res) => {
      setOrderData(res.data.data);
    });
    axios.get(`${legolasApi.url}/shipment/${order.id}`).then((res) => {
        
    });
  },[])

  const handleBackClick = () => {
      navigate('/shipments')
  }

  const closeAlert = () => {
    setOpenAlert(false)
  }
  const darkBox = {
    width: '96%', 
    display: 'inline-flex', 
    justifyContent: 'space-between', 
    backgroundColor: '#dcdbdb',
    padding: '10px'
  }
  const lightBox = {
    width: '96%', 
    display: 'inline-flex', 
    justifyContent: 'space-between', 
    backgroundColor: '#fff',
    padding: '10px'
  }

  const subHeader = {
    fontSize: '1.2rem',
    fontWeight: 700,
    paddingBottom: '20px'
  }

  const purchasedFromDefault = 'Shababuna Website'
  const purchasedIPDefault = 'NULL'
  if (orderData == null) {
    return
  }
  const { summary, shipment, transaction, items, customer } = orderData 

  const AddressInfo = () => {
    return (
      <React.Fragment>
        <Box sx={{ display: 'inline-flex' }}>
          <Typography sx={{ paddingRight: '5px' }}>{shipment.customer_firstname ? shipment.customer_firstname : null}</Typography>
          <Typography>{shipment.customer_lastname ? shipment.customer_lastname : null}</Typography>
        </Box>
        <Typography>{shipment.street ? shipment.street : null}</Typography>
        <Typography>{shipment.district ? shipment.district : null}</Typography>
        <Box sx={{ display: 'inline-flex' }}>
          <Typography>{shipment.city ? shipment.city : null}</Typography>,
          <Typography sx={{ paddingLeft: '5px' }}>{shipment.postcode ? shipment.postcode : 560034}</Typography>
        </Box>
        <Typography>{shipment.country ? shipment.country : null}</Typography>
        <Box sx={{ display: 'inline-flex'}}>
          <Typography sx={{ paddingRight: '5px' }}>T:</Typography>
          <Typography>{shipment.phone ? shipment.phone : null}</Typography>
        </Box>
        {shipment.po_number !== null &&
        <Box sx={{ display: 'inline-flex' }}>
          <Typography sx={{ paddingRight: '5px' }}>PO:</Typography>
          <Typography>{shipment.po_number ?  shipment.po_number : null}</Typography>
        </Box>
        }
      </React.Fragment>
    )
  }
  return (
    <Box sx={{ width: '97%', height: 'auto', backgroundColor: '#fff !important', margin: '0px 20px' }}>
      <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeAlert} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
          {alertText}
        </Alert>
      </Snackbar>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', margin: '30px 20px',
        '& .MuiTypography-root': {
          fontSize: '2.5rem',
          fontWeight: 400,
          color: '#000'
        }}}>
          <Typography>#{order.orderId}</Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', backgroundColor: globalStyles.colors.lightGrey,
        margin: '15px 0px',
        '& .MuiButton-root': {
          padding: '10px 30px',
          backgroundColor: globalStyles.colors.backgroundPrimary,
          color: globalStyles.colors.white,
          borderRadius: '0px',
          margin: '10px',
          textTransform: 'capitalize'
        }
        }}
        >
          <Button onClick={() => handleBackClick()}>Back</Button>
          {/* <Button onClick={() => printAndSendInvoice()}>Print & Send Invoice</Button> */}
          {/* <Button onClick={() => sendEmail()}>Send Email</Button> */}
          {/* <Button onClick={() => createPdf()}>Print</Button> */}
        </Box>
        <Box id='order-container'>
          <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
            <Typography variant='h6'>Order & Account Information</Typography>
          </Box>
          <Grid container spacing={5} columns={24}>
            <Grid item xs={12}>
            <Typography variant='subtitle1' sx={subHeader}>
              Order # {orderData.summary.order_id} (The order confirmation email was sent)
            </Typography>
            <Box sx={darkBox}>
              <Typography>Order Date</Typography>
              <Typography>{summary.placedOn}</Typography>
            </Box>
            <Box sx={lightBox}>
              <Typography>Order Status</Typography>
              {summary.order_status ?
              <Typography>{summary.order_status}</Typography> : <Typography sx={{ color: 'red' }}>Order status not set</Typography>}
            </Box>
            <Box sx={darkBox}>
              <Typography>Purchased From</Typography>
              {summary.purchasedFrom ?
              <Typography>{summary.purchasedFrom}</Typography> : <Typography>{purchasedFromDefault}</Typography>}
            </Box>
          {/*  <Box sx={lightBox}>
              <Typography>Purchased From IP</Typography>
              {summary.order_ip ?
              <Typography>{summary.order_ip}</Typography> : <Typography>{purchasedIPDefault}</Typography>}
            </Box>
              */}
            </Grid>
            <Grid item xs={12}>
              <Typography variant='subtitle1' sx={subHeader}>
                Account Information
              </Typography>
              <Box sx={darkBox}>
                <Typography>Customer Name</Typography>
                <Typography>{shipment.customer_firstname + ' ' + shipment.customer_lastname}</Typography>
              </Box>
              <Box sx={lightBox}>
                <Typography>Phone</Typography>
                {shipment.phone_ext && shipment.phone ?
                <Typography>{shipment.phone_ext + shipment.phone}</Typography> : <Typography sx={{ color: 'red' }}>Email not set</Typography>}
              </Box>
              <Box sx={darkBox}>
                <Typography>Customer Group</Typography>
                <Typography>GENERAL</Typography>
                {/*{customer.user_group_code ?
                <Typography>{customer.user_group_code}</Typography> : <Typography sx={{ color: 'red' }}>Group not set</Typography>}
                */}
              </Box>
              <Box sx={lightBox}>
                <Typography>Tracking No.</Typography>
                {shipment.phone_ext && shipment.phone ?
                <Typography>{shipment.phone_ext + shipment.phone}</Typography> : <Typography sx={{ color: 'red' }}>Email not set</Typography>}
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box id='addressinfo-box' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Address Information
          </Typography>
        </Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Billing Address
            </Typography>
            <AddressInfo/>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Shipping Address
            </Typography>
            <AddressInfo/>
          </Grid>
        </Grid>
      </Box>
      <Box id='paymentinfo-box' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Payment & Shipping Method
          </Typography>
        </Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Payment Information
            </Typography>
            <Box>
              <Typography>{transaction.paymentType ? transaction.paymentType : null}</Typography>
                {
                  transaction.last4Digits && 
                  <Typography>
                    {transaction.last4Digits}
                  </Typography>
                }
              <Typography>{transaction.paymentBrand ? transaction.paymentBrand : null}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
              Shipping & Handling Information
            </Typography>
          </Grid>
         </Grid>
      </Box>
      <Box id='itemsinfo-box' sx={{ paddingTop: '50px' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Items Invoiced
          </Typography>
        </Box>
        <Box>
          <ItemsList data={items ? items : []} source='order-info'/>
        </Box>
      </Box>
      <Box id='total-container' sx={{ paddingTop: '50px' }}>
          <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
            <Typography variant='h6'>Order Total</Typography>
          </Box>
          <Grid container spacing={5} columns={24} sx={{ flexDirection: 'row-reverse' }}>
            {/* <Grid item xs={12}>
              <Typography variant='subtitle1' sx={subHeader}>
                Invoice History
              </Typography>
              <Box>
              <TextareaAutosize
                aria-label="minimum height"
                minRows={5}
                placeholder="Invoice Comments"
                style={{ width: 500 }}
              />
              </Box>
            </Grid> */}
            <Grid item xs={12}>
              <Typography variant='subtitle1' sx={subHeader}>
                Invoice Totals
              </Typography>
              <Box sx={{ paddingBottom: '10px' }}>
                <Box sx={darkBox}>
                  <Typography>Subtotal</Typography>
                  <Typography>SAR {summary.subtotal_incl_tax ? parseFloat(summary.subtotal_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
                </Box>
                <Box sx={lightBox}>
                  <Typography>Shipping & Handling</Typography>
                  <Typography>SAR {summary.shipping_incl_tax ? parseFloat(summary.shipping_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
                </Box>
                <Box sx={darkBox}>
                  <Typography>Tax</Typography>
                  <Typography>SAR {summary.total_tax ? parseFloat(summary.total_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
                </Box>
                <Box sx={lightBox}>
                  <Typography>Cash on Delivery Fee (incl. Tax)</Typography>
                  <Typography>SAR {summary.cod_fee_incl_tax ? parseFloat(summary.cod_fee_incl_tax).toFixed(2) : (0.00).toFixed(2)}</Typography>
                </Box>
                <Box sx={darkBox}>
                  <Typography sx={{ fontSize: '1rem', fontWeight: 700 }}>Grand Total</Typography>
                  <Typography>SAR {summary.grand_total ? parseFloat(summary.grand_total).toFixed(2) : (0.00).toFixed(2)}</Typography>
                </Box>
              </Box>
              {/* <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                <Button 
                  sx={{ 
                    backgroundColor: '#2b3f7a !important', 
                    borderRadius: 0, 
                    padding: '15px 20px', 
                    color: '#fff',
                    textTransform: 'capitalize'
                  }}
                  onClick={() => handleInvoiceSubmit()}
                >
                  Submit Invoice
                </Button>
              </Box> */}
              </Grid>
          </Grid>
        </Box>
    </Box>
  )
}

export default ShipmentDetails;